import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

const HeadContainer = React.memo((mvtParams) => {

    const renderPreconnects = () => (
        <>
            <link
                rel="preconnect"
                src="https://js-agent.newrelic.com"
            />
            <link
                rel="preconnect"
                src="https://bam.nr-data.net"
            />
            <link
                rel="preconnect"
                src="https://securepubads.g.doubleclick.net"
            />
            <link
                rel="preconnect"
                src="https://connect.facebook.net"
            />
            <link
                rel="preconnect"
                src="https://www.googletagmanager.com"
            />
            <link
                rel="preconnect"
                src="https://smetrics.autotrader.com"
            />
        </>
    );

    return (
        <Head>
            {mvtParams.launchOpt1 && renderPreconnects()}
        </Head>
    );
});

HeadContainer.propTypes = {
    mvtParams: PropTypes.object,
};

export default HeadContainer;
